import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M18 11l-6 -6","key":"svg-1"}],["path",{"d":"M6 11l6 -6","key":"svg-2"}]]

const IconArrowUp = createReactComponent('outline', 'arrow-up', 'ArrowUp', __iconNode);

export default IconArrowUp;